import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  cs: {
    translation: {
      // ===== LEGACY KEYS (kept for backward compatibility) =====

      // Home
      home_title: "Vítejte v Klientské zóně Codaco",
      home_text_1:
        "Zde si můžete stáhnout aktuální firmware, projektovou směrnici, montážní návody a další dokumenty.",
      home_text_2:
        "Pro přístup k obsahu se prosím přihlaste nebo zaregistrujte.",

      // Auth common
      email: "Email",
      password: "Heslo",
      btn_login: "Přihlásit se",
      btn_register: "Registrovat se",

      // Header
      login: "Přihlášení",
      register: "Registrace",
      documents: "Dokumenty",
      firmware: "Firmware",
      client_admin: "Správa klientů",
      client_logs: "Logy klientů",
      service_admin: "Správa servisáků",
      service_logs: "Logy servisáků",
      logout: "Odhlásit se",

      // Register
      reg_title: "Registrace",
      name: "Jméno",
      surname: "Příjmení",
      phone: "Telefon",
      company: "Společnost",
      account_type: "Typ účtu",
      role_client: "Klient / Partner (Přístup k technické dokumentaci)",
      role_service: "Servisní technik (Přístup k aktuálním verzím firmwarů)",
      confirm_password: "Potvrzení hesla",
      required_fields: "označuje povinné pole",
      agree_gdpr: "Souhlasím se",
      agree_gdpr_link: "zpracováním osobních údajů",
      alert_agree_gdpr:
        "Pro pokračování musíte souhlasit se zpracováním osobních údajů.",
      alert_pass_mismatch: "Hesla se neshodují.",
      alert_email_used: "Uživatel s tímto e-mailem již existuje.",
      alert_reg_failed: "Registrace se nezdařila. Zkuste to prosím znovu.",

      // Login
      title_login: "Přihlášení",
      title_password_reset: "Obnova hesla",
      email_placeholder: "Zadejte email",
      btn_send_reset_email: "Odeslat email",
      btn_back_to_login: "Zpět na přihlášení",
      link_forgot_password: "Zapomenuté heslo?",
      error_login_invalid: "Neplatný email nebo heslo.",
      error_reset_email:
        "Uživatel s tímto emailem nebyl nalezen nebo nastala chyba.",
      msg_reset_email_sent: "Email pro obnovení hesla byl odeslán.",

      // Password input
      show_password: "Zobrazit heslo",
      hide_password: "Skrýt heslo",

      // Dashboard
      dashboard_heading: "Dostupné dokumenty ke stažení",
      dashboard_download_button: "Stáhnout",
      dashboard_downloading: "Stahování...",
      dashboard_download_done: "Hotovo ✓",
      dashboard_file_1: "Montážní návod HCC-07 IP 2025",
      dashboard_file_2: "Projektová směrnice HCC-07 IP 2025",
      dashboard_file_3: "Katalog produktů HCC-07 IP 2025",
      dashboard_file_4: "Montážní návod HCC-01.5 2025",

      // Firmware
      fw_title: "Firmware ke stažení",
      select_system: "Vyberte systém:",
      select_placeholder: "Vyberte systém",
      new_folder: "Nová složka",
      add_system: "Přidat systém",
      delete_system: "Smazat systém",
      deleting: "Mazání...",
      path: "Cesta:",
      upload_title: "Nahrání firmware",
      target: "Cíl:",
      file: "Soubor",
      version: "Verze",
      note_optional: "Poznámka (volitelně)",
      uploading: "Nahrávání...",
      btn_upload: "Nahrát",
      progress: "Průběh:",
      folders: "Složky",
      files: "Soubory",
      th_file: "Soubor",
      th_original_name: "Původní název",
      th_upload_date: "Datum vložení",
      th_note: "Poznámka",
      th_size: "Velikost",
      th_action: "Akce",
      downloading: "Stahování...",
      btn_download: "Stáhnout",
      btn_delete: "Smazat",
      empty_folder: "Tato složka je prázdná.",
      save: "Uložit",
      saving: "Ukládám...",
      cancel: "Zrušit",
      new_name: "Nový název",
      rename_folder: "Přejmenovat složku",
      prompt_sys_name: "Zadejte název nového systému:",
      prompt_variant_name: "Zadejte název nové varianty:",
      prompt_folder_name: "Zadejte název nové složky:",
      delete_system_confirm: 'Opravdu chcete smazat systém "{{dev}}"?',
      confirm_delete_file: 'Opravdu chcete smazat soubor "{{name}}"?',
      confirm_delete_folder: 'Opravdu chcete smazat složku "{{name}}"?',
      open_folder: "Otevřít složku",
      files_count: "{{count}} souborů",
      err_select_system: "Nejprve vyberte systém.",
      err_invalid_sys_name: "Neplatný název systému.",
      err_invalid_folder_name: "Neplatný název složky.",

      // Footer
      footer_credit: "Vytvořil Vladan Dwornik",

      // Common
      error: "Chyba",

      // ===== NEW STRUCTURED KEYS =====

      home: {
        title: "Vítejte v Klientské zóně Codaco",
        text1:
          "Zde si můžete stáhnout aktuální firmware, projektovou směrnici, montážní návody a další dokumenty.",
        text2: "Pro přístup k obsahu se prosím přihlaste nebo zaregistrujte.",
      },

      header: {
        login: "Přihlášení",
        register: "Registrace",
        documents: "Dokumenty",
        firmware: "Firmware",
        clientAdmin: "Správa klientů",
        clientLogs: "Logy klientů",
        serviceAdmin: "Správa servisáků",
        serviceLogs: "Logy servisáků",
        logout: "Odhlásit se",
      },

      auth: {
        email: "Email",
        password: "Heslo",
        emailPlaceholder: "Zadejte email",
        loginTitle: "Přihlášení",
        resetTitle: "Obnova hesla",
        loginButton: "Přihlásit se",
        registerButton: "Registrovat se",
        sendResetEmailButton: "Odeslat email",
        backToLoginButton: "Zpět na přihlášení",
        forgotPasswordLink: "Zapomenuté heslo?",
        errors: {
          invalidLogin: "Neplatný email nebo heslo.",
          resetEmail:
            "Uživatel s tímto emailem nebyl nalezen nebo nastala chyba.",
        },
        messages: {
          resetEmailSent: "Email pro obnovení hesla byl odeslán.",
        },
      },

      registerPage: {
        title: "Registrace",
        name: "Jméno",
        surname: "Příjmení",
        phone: "Telefon",
        company: "Společnost",
        contactPerson: "Ověřovací kontakt",
        contactPersonHelper: "Kdo Vás odkázal na Klientskou zónu?",
        accountType: "Typ účtu",
        roleClient: "Klient / Partner (Přístup k technické dokumentaci)",
        roleService: "Servisní technik (Přístup k aktuálním verzím firmwarů)",
        confirmPassword: "Potvrzení hesla",
        requiredFields: "označuje povinné pole",
        agreeGdpr: "Souhlasím se",
        agreeGdprLink: "zpracováním osobních údajů",
        alerts: {
          agreeGdpr:
            "Pro pokračování musíte souhlasit se zpracováním osobních údajů.",
          passwordMismatch: "Hesla se neshodují.",
          emailUsed: "Uživatel s tímto e-mailem již existuje.",
          registrationFailed:
            "Registrace se nezdařila. Zkuste to prosím znovu.",
        },
      },

      registeredInfo: {
        title: "Vaše registrace byla úspěšná",
        text1:
          "Administrátor ji posoudí do 1 pracovního dne. Po schválení vám bude umožněn přístup ke stažení aktuálního firmware či příslušné dokumentace.",
        text2:
          "O výsledku vás budeme informovat e-mailem, který jste uvedli při registraci.",
        noteLabel: "📩 Zkontrolujte také složku:",
        noteSpam: "Spam",
        noteBulk: "Hromadné",
        thanks: "Děkujeme.",
      },

      dashboard: {
        heading: "Dostupné dokumenty ke stažení",
        downloadButton: "Stáhnout",
        downloading: "Stahování...",
        downloadDone: "Hotovo ✓",
        files: {
          installationManualHcc07: "Montážní návod HCC-07 IP 2025",
          projectGuidelineHcc07: "Projektová směrnice HCC-07 IP 2025",
          productCatalogHcc07: "Katalog produktů HCC-07 IP 2025",
          installationManualHcc015: "Montážní návod HCC-01.5 2025",
        },
      },

      footer: {
        credit: "Vytvořil Vladan Dwornik",
      },

      common: {
        showPassword: "Zobrazit heslo",
        hidePassword: "Skrýt heslo",
        error: "Chyba",
      },

      validation: {
        required: "Vyplňte prosím toto pole.",
        email: "Zadejte platnou e-mailovou adresu.",
      },

      firmwarePage: {
        fileChoose: "Vybrat soubor",
        fileNotSelected: "Soubor nevybrán",
        title: "Firmware ke stažení",
        selectSystem: "Vyberte systém:",
        selectPlaceholder: "Vyberte systém",
        newFolder: "Nová složka",
        addSystem: "Přidat systém",
        deleteSystem: "Smazat systém",
        deleting: "Mazání...",
        path: "Cesta:",
        currentFolder: "Aktuální složka",
        goToLevel: "Přejít na úroveň",
        uploadTitle: "Nahrání firmware",
        target: "Cíl:",
        file: "Soubor",
        version: "Verze",
        versionPlaceholder: "např. 1.2.3",
        noteOptional: "Poznámka (volitelně)",
        notePlaceholder: "např. oprava restartů, nové senzory…",
        uploading: "Nahrávání...",
        uploadButton: "Nahrát",
        progress: "Průběh:",
        loading: "Načítám…",
        folders: "Složky",
        files: "Soubory",
        openFolder: "Otevřít složku",
        downloadButton: "Stáhnout",
        downloading: "Stahování...",
        deleteButton: "Smazat",
        renameFolder: "Přejmenovat složku",
        newName: "Nový název",
        save: "Uložit",
        saving: "Ukládám...",
        cancel: "Zrušit",
        emptyFolder: "Tato složka je prázdná.",
        downloadFile: "Stáhnout soubor",
        deleteFile: "Smazat soubor",
        promptSystemName: "Zadejte název nového systému:",
        promptVariantName: "Zadejte název nové varianty:",
        promptFolderName: "Zadejte název nové složky:",
        confirmDeleteSystem: 'Opravdu chcete smazat systém "{{dev}}"?',
        confirmDeleteFile: 'Opravdu chcete smazat soubor "{{name}}"?',
        confirmDeleteFolder: 'Opravdu chcete smazat složku "{{name}}"?',
        filesCount: "{{count}} souborů",
        openUploadModal: "Nahrát firmware",
        closeUploadModal: "Zavřít okno nahrání",
        dragDropHint: "Přetáhněte soubor sem nebo jej vyberte",
        warnings: {
          metadataSaveFailed:
            "Soubor byl nahrán, ale nepodařilo se uložit metadata. Obnov stránku.",
        },
        errors: {
          selectSystem: "Nejprve vyberte systém.",
          invalidSystemName: "Neplatný název systému.",
          invalidFolderName: "Neplatný název složky.",
          invalidFolderDisplayName: "Neplatný název složky.",
          uploadOnlyInTargetFolder:
            "Nahrávání je dostupné jen v cílové složce.",
          uploadFileMissing: "Vyberte soubor k nahrání.",
          versionMissing: "Zadejte verzi firmware.",
          fileKeyMissing: "U souboru chybí key/path – nelze stáhnout.",
          downloadUrlMissing: "Backend nevrátil downloadUrl.",
          uploadUrlMissing: "Backend nevrátil uploadUrl/key.",
          newFolderOnlyAtAllowedLevel:
            "Novou složku lze vytvořit jen na úrovni systému nebo varianty.",
          channelRenameNotAllowed:
            "Složky release/beta/archive nelze přejmenovat.",
          renameEmpty: "Název nesmí být prázdný.",
          renameInvalid: "Neplatný název.",
          renameInvalidNormalized: "Neplatný název (po normalizaci).",
          targetPrefixExists: "Cílová složka už existuje. Zvol jiný název.",
          moveSameParentOnly:
            "Složku lze přejmenovat jen v rámci stejného umístění.",
          rootMoveNotAllowed: "Kořen systému nelze přejmenovat.",
          renameFailed: "Nepodařilo se přejmenovat složku.",
        },
        table: {
          file: "Soubor",
          originalName: "Původní název",
          uploadDate: "Datum vložení",
          note: "Poznámka",
          size: "Velikost",
          action: "Akce",
        },
      },
    },
  },

  en: {
    translation: {
      // ===== LEGACY KEYS (kept for backward compatibility) =====

      // Home
      home_title: "Welcome to the Codaco Client Zone",
      home_text_1:
        "Here you can download the latest firmware, project guidelines, installation manuals and other documents.",
      home_text_2: "To access the content, please sign in or register.",

      // Auth common
      email: "Email",
      password: "Password",
      btn_login: "Sign in",
      btn_register: "Register",

      // Header
      login: "Login",
      register: "Register",
      documents: "Documents",
      firmware: "Firmware",
      client_admin: "Client Management",
      client_logs: "Client Logs",
      service_admin: "Service Management",
      service_logs: "Service Logs",
      logout: "Logout",

      // Register
      reg_title: "Registration",
      name: "Name",
      surname: "Surname",
      phone: "Phone",
      company: "Company",
      account_type: "Account Type",
      role_client: "Client / Partner (Access to technical documentation)",
      role_service: "Service Technician (Access to firmware versions)",
      confirm_password: "Confirm Password",
      required_fields: "indicates a required field",
      agree_gdpr: "I agree to the",
      agree_gdpr_link: "processing of personal data",
      alert_agree_gdpr:
        "You must agree to the processing of personal data to continue.",
      alert_pass_mismatch: "Passwords do not match.",
      alert_email_used: "A user with this email already exists.",
      alert_reg_failed: "Registration failed. Please try again.",

      // Login
      title_login: "Sign In",
      title_password_reset: "Reset Password",
      email_placeholder: "Enter your email",
      btn_send_reset_email: "Send Reset Email",
      btn_back_to_login: "Back to Login",
      link_forgot_password: "Forgot password?",
      error_login_invalid: "Invalid email or password.",
      error_reset_email:
        "User with this email was not found or an error occurred.",
      msg_reset_email_sent: "Password reset email has been sent.",

      // Password input
      show_password: "Show password",
      hide_password: "Hide password",

      // Dashboard
      dashboard_heading: "Available documents for download",
      dashboard_download_button: "Download",
      dashboard_downloading: "Downloading...",
      dashboard_download_done: "Done ✓",
      dashboard_file_1: "Installation Manual HCC-07 IP 2025",
      dashboard_file_2: "Project Guideline HCC-07 IP 2025",
      dashboard_file_3: "Product Catalog HCC-07 IP 2025",
      dashboard_file_4: "Installation Manual HCC-01.5 2025",

      // Firmware
      fw_title: "Firmware Downloads",
      select_system: "Select system:",
      select_placeholder: "Select system",
      new_folder: "New folder",
      add_system: "Add system",
      delete_system: "Delete system",
      deleting: "Deleting...",
      path: "Path:",
      upload_title: "Firmware Upload",
      target: "Target:",
      file: "File",
      version: "Version",
      note_optional: "Note (optional)",
      uploading: "Uploading...",
      btn_upload: "Upload",
      progress: "Progress:",
      folders: "Folders",
      files: "Files",
      th_file: "File",
      th_original_name: "Original name",
      th_upload_date: "Upload date",
      th_note: "Note",
      th_size: "Size",
      th_action: "Action",
      downloading: "Downloading...",
      btn_download: "Download",
      btn_delete: "Delete",
      empty_folder: "This folder is empty.",
      save: "Save",
      saving: "Saving...",
      cancel: "Cancel",
      new_name: "New name",
      rename_folder: "Rename folder",
      prompt_sys_name: "Enter the new system name:",
      prompt_variant_name: "Enter the new variant name:",
      prompt_folder_name: "Enter the new folder name:",
      delete_system_confirm:
        'Are you sure you want to delete system "{{dev}}"?',
      confirm_delete_file: 'Are you sure you want to delete file "{{name}}"?',
      confirm_delete_folder:
        'Are you sure you want to delete folder "{{name}}"?',
      open_folder: "Open folder",
      files_count: "{{count}} files",
      err_select_system: "Please select a system first.",
      err_invalid_sys_name: "Invalid system name.",
      err_invalid_folder_name: "Invalid folder name.",

      // Footer
      footer_credit: "Developed by Vladan Dwornik",

      // Common
      error: "Error",

      // ===== NEW STRUCTURED KEYS =====

      home: {
        title: "Welcome to the Codaco Client Zone",
        text1:
          "Here you can download the latest firmware, project guidelines, installation manuals and other documents.",
        text2: "To access the content, please sign in or register.",
      },

      header: {
        login: "Login",
        register: "Register",
        documents: "Documents",
        firmware: "Firmware",
        clientAdmin: "Client Management",
        clientLogs: "Client Logs",
        serviceAdmin: "Service Management",
        serviceLogs: "Service Logs",
        logout: "Logout",
      },

      auth: {
        email: "Email",
        password: "Password",
        emailPlaceholder: "Enter your email",
        loginTitle: "Sign In",
        resetTitle: "Reset Password",
        loginButton: "Sign in",
        registerButton: "Register",
        sendResetEmailButton: "Send Reset Email",
        backToLoginButton: "Back to Login",
        forgotPasswordLink: "Forgot password?",
        errors: {
          invalidLogin: "Invalid email or password.",
          resetEmail:
            "User with this email was not found or an error occurred.",
        },
        messages: {
          resetEmailSent: "Password reset email has been sent.",
        },
      },

      registerPage: {
        title: "Registration",
        name: "Name",
        surname: "Surname",
        phone: "Phone",
        company: "Company",
        contactPerson: "Verification contact",
        contactPersonHelper: "Who referred you to the Client Zone?",
        accountType: "Account Type",
        roleClient: "Client / Partner (Access to technical documentation)",
        roleService: "Service Technician (Access to firmware versions)",
        confirmPassword: "Confirm Password",
        requiredFields: "indicates a required field",
        agreeGdpr: "I agree to the",
        agreeGdprLink: "processing of personal data",
        alerts: {
          agreeGdpr:
            "You must agree to the processing of personal data to continue.",
          passwordMismatch: "Passwords do not match.",
          emailUsed: "A user with this email already exists.",
          registrationFailed: "Registration failed. Please try again.",
        },
      },

      registeredInfo: {
        title: "Your registration was successful",
        text1:
          "An administrator will review it within 1 business day. After approval, you will be granted access to download the latest firmware or related documentation.",
        text2:
          "We will inform you about the result by email sent to the address provided during registration.",
        noteLabel: "📩 Please also check folder:",
        noteSpam: "Spam",
        noteBulk: "Promotions",
        thanks: "Thank you.",
      },

      dashboard: {
        heading: "Available documents for download",
        downloadButton: "Download",
        downloading: "Downloading...",
        downloadDone: "Done ✓",
        files: {
          installationManualHcc07: "Installation Manual HCC-07 IP 2025",
          projectGuidelineHcc07: "Project Guideline HCC-07 IP 2025",
          productCatalogHcc07: "Product Catalog HCC-07 IP 2025",
          installationManualHcc015: "Installation Manual HCC-01.5 2025",
        },
      },

      footer: {
        credit: "Developed by Vladan Dwornik",
      },

      common: {
        showPassword: "Show password",
        hidePassword: "Hide password",
        error: "Error",
      },

      validation: {
        required: "Please fill out this field.",
        email: "Please enter a valid email address.",
      },

      firmwarePage: {
        fileChoose: "Choose file",
        fileNotSelected: "No file selected",
        title: "Firmware Downloads",
        selectSystem: "Select system:",
        selectPlaceholder: "Select system",
        newFolder: "New folder",
        addSystem: "Add system",
        deleteSystem: "Delete system",
        deleting: "Deleting...",
        path: "Path:",
        currentFolder: "Current folder",
        goToLevel: "Go to level",
        uploadTitle: "Firmware Upload",
        target: "Target:",
        file: "File",
        version: "Version",
        versionPlaceholder: "e.g. 1.2.3",
        noteOptional: "Note (optional)",
        notePlaceholder: "e.g. reboot fix, new sensors…",
        uploading: "Uploading...",
        uploadButton: "Upload",
        progress: "Progress:",
        loading: "Loading…",
        folders: "Folders",
        files: "Files",
        openFolder: "Open folder",
        downloadButton: "Download",
        downloading: "Downloading...",
        deleteButton: "Delete",
        renameFolder: "Rename folder",
        newName: "New name",
        save: "Save",
        saving: "Saving...",
        cancel: "Cancel",
        emptyFolder: "This folder is empty.",
        downloadFile: "Download file",
        deleteFile: "Delete file",
        promptSystemName: "Enter the new system name:",
        promptVariantName: "Enter the new variant name:",
        promptFolderName: "Enter the new folder name:",
        confirmDeleteSystem:
          'Are you sure you want to delete system "{{dev}}"?',
        confirmDeleteFile: 'Are you sure you want to delete file "{{name}}"?',
        confirmDeleteFolder:
          'Are you sure you want to delete folder "{{name}}"?',
        filesCount: "{{count}} files",
        openUploadModal: "Upload firmware",
        closeUploadModal: "Close upload window",
        dragDropHint: "Drag and drop a file here or choose one",
        warnings: {
          metadataSaveFailed:
            "The file was uploaded, but metadata could not be saved. Refresh the page.",
        },
        errors: {
          selectSystem: "Please select a system first.",
          invalidSystemName: "Invalid system name.",
          invalidFolderName: "Invalid folder name.",
          invalidFolderDisplayName: "Invalid folder name.",
          uploadOnlyInTargetFolder:
            "Upload is only available in the target folder.",
          uploadFileMissing: "Please select a file to upload.",
          versionMissing: "Please enter the firmware version.",
          fileKeyMissing:
            "The file is missing key/path and cannot be downloaded.",
          downloadUrlMissing: "The backend did not return downloadUrl.",
          uploadUrlMissing: "The backend did not return uploadUrl/key.",
          newFolderOnlyAtAllowedLevel:
            "A new folder can only be created at the system or variant level.",
          channelRenameNotAllowed:
            "release/beta/archive folders cannot be renamed.",
          renameEmpty: "The name cannot be empty.",
          renameInvalid: "Invalid name.",
          renameInvalidNormalized: "Invalid name after normalization.",
          targetPrefixExists:
            "The target folder already exists. Choose another name.",
          moveSameParentOnly:
            "A folder can only be renamed within the same location.",
          rootMoveNotAllowed: "The system root cannot be renamed.",
          renameFailed: "The folder could not be renamed.",
        },
        table: {
          file: "File",
          originalName: "Original name",
          uploadDate: "Upload date",
          note: "Note",
          size: "Size",
          action: "Action",
        },
      },
    },
  },
};

const detectionOptions = {
  order: ["localStorage", "navigator", "htmlTag"],
  caches: ["localStorage"],
  lookupLocalStorage: "i18nextLng",
  convertDetectedLanguage: (lng) => {
    const normalized = String(lng || "")
      .toLowerCase()
      .replace("_", "-");

    if (normalized.startsWith("cs")) return "cs";
    if (normalized.startsWith("en")) return "en";
    return "cs";
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "cs",
    supportedLngs: ["cs", "en"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    lowerCaseLng: true,
    cleanCode: true,
    defaultNS: "translation",
    returnNull: false,
    detection: detectionOptions,
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    const finalLng = lng === "en" ? "en" : "cs";
    document.documentElement.lang = finalLng;
    document.documentElement.setAttribute("translate", "no");
    document.body?.setAttribute("translate", "no");
    document.documentElement.classList.add("notranslate");
    document.body?.classList.add("notranslate");
  }
});

if (typeof document !== "undefined") {
  const initialLng = i18n.resolvedLanguage === "en" ? "en" : "cs";
  document.documentElement.lang = initialLng;
  document.documentElement.setAttribute("translate", "no");
  document.body?.setAttribute("translate", "no");
  document.documentElement.classList.add("notranslate");
  document.body?.classList.add("notranslate");
}

export default i18n;
